export type Shortcode = {
  type: string
  attributes: Record<string, string | null>
  children: Shortcode[]
  content: string
}

export function parseShortcodes(content: string, strictMode?: boolean) {
  const shortcodes: Shortcode[] = []

  const regex = /\[(\/?[a-z0-9-]+)([\s\S]*?)(\/?)\]/gi
  const stack: Shortcode[] = []

  let lastMatchEnd = 0
  let match
  while ((match = regex.exec(content)) !== null) {
    const isClosing = match[1].startsWith('/')
    const type = isClosing ? match[1].slice(1) : match[1]
    const attributes = parseAttributes(match[2])
    const isSelfClosing = !!match[3]

    if (strictMode && (isSelfClosing || !stack.length)) {
      continue
    }

    if (isClosing) {
      const openShortcode = stack.pop()
      if (openShortcode && openShortcode.type === type) {
        const parent = stack[stack.length - 1]
        openShortcode.content = content.slice(lastMatchEnd, match.index).trim()
        if (parent) {
          parent.children.push(openShortcode)
        } else {
          shortcodes.push(openShortcode)
        }
      }
    } else {
      const shortcode: Shortcode = {
        type,
        attributes,
        children: [],
        content: ''
      }

      stack.push(shortcode)
      if (isSelfClosing) {
        stack.pop()
        const parent = stack[stack.length - 1]
        if (parent) {
          parent.children.push(shortcode)
        } else {
          shortcodes.push(shortcode)
        }
      } else {
        shortcodes.push(shortcode)
      }
    }

    lastMatchEnd = regex.lastIndex
  }

  return shortcodes
}

function parseAttributes(attributeString: string) {
  const attributes: Record<string, string | null> = {}
  const attributeRegex = /([a-z0-9-]+)(="?([^"]+)?"?)?/gi
  let attributeMatch: RegExpExecArray | null

  while ((attributeMatch = attributeRegex.exec(attributeString)) !== null) {
    attributes[attributeMatch[1]!] = attributeMatch[3] || null
  }

  return attributes
}

export function parseTooltips(content: string) {
  const shortcodes = parseShortcodes(content)

  if (shortcodes.length === 0) {
    return content
  }

  if (shortcodes.length > 0) {
    return replaceShortcodes(content)
  }

  return <span>{content}</span>
}

export function replaceShortcodes(content: string, strictMode?: boolean) {
  const shortcodes = parseShortcodes(content, strictMode)

  if (shortcodes.length === 0) {
    return content
  }

  let result = content

  shortcodes.forEach((shortcode) => {
    const shortcodeContent = `<span class="${shortcode.type}">${shortcode.content}</span>`
    const shortcodeRegex = new RegExp(
      `\\[${shortcode.type}\\]${shortcode.content}\\[\\/${shortcode.type}\\]`,
      'g'
    )
    result = result.replace(shortcodeRegex, shortcodeContent)
  })

  return result
}
